<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      title: "Settings",
      text: "Customer",
      text1: "Settings",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/provider-settings/device-management");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <h4>Device Management</h4>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="table-resposnive">
                  <table class="table datatable">
                    <thead>
                      <tr>
                        <th>Device Name</th>
                        <th>Date</th>
                        <th>IP Address</th>
                        <th>Location</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><p class="fs-14">Chrome - Windows</p></td>
                        <td>
                          <p class="text-gray fs-14">22 Sep 2022, 11:40:30</p>
                        </td>
                        <td><p class="text-gray fs-14">232.222.12.72</p></td>
                        <td><p class="fs-14 text-gray">Chennai / India</p></td>
                        <td>
                          <span class="badge badge-danger-transparent p-2">Delete</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Safari Macos</p></td>
                        <td>
                          <p class="text-gray fs-14">21 Sep 2022, 13:10:50</p>
                        </td>
                        <td><p class="text-gray fs-14">224.111.12.75</p></td>
                        <td><p class="fs-14 text-gray">Newyork / USA</p></td>
                        <td>
                          <span class="badge badge-danger-transparent p-2">Delete</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Firefox Windows</p></td>
                        <td>
                          <p class="text-gray fs-14">20 Sep 2022, 14:16:10</p>
                        </td>
                        <td><p class="text-gray fs-14">111.222.13.28</p></td>
                        <td><p class="fs-14 text-gray">Chennai / India</p></td>
                        <td>
                          <span class="badge badge-danger-transparent p-2">Delete</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Safari Macos</p></td>
                        <td>
                          <p class="text-gray fs-14">19 Sep 2022, 10:20:20</p>
                        </td>
                        <td><p class="text-gray fs-14">333.555.10.54</p></td>
                        <td><p class="fs-14 text-gray">Chennai / India</p></td>
                        <td>
                          <span class="badge badge-danger-transparent p-2">Delete</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <security-settings-modal></security-settings-modal>
</template>
